import { useDispatch, useSelector } from 'react-redux';
import { Checkbox, ICheckboxOptions } from '../../../../../component';
import { RootState } from '../../../../../reducer';
import { updateOptions } from '../../redux/dataLayers.actions';
import { removeFlowPoint, showFlowPoint } from '../../redux/dataLayers.map';
import { Map } from 'eemovel-map-library';

export type FlowPoint = {
  id: string;
  label: string;
  checked: boolean;
  markers: google.maps.Marker[];
};

function FlowPointsOptions() {
  const { preference } = useSelector((state: any) => state.layoutState);
  const nls = require(`../../nls/${preference.language.id}.json`);
  const {
    dataLayersState: { dataLayers },
    polygonsState: { draw },
  } = useSelector((state: RootState) => state);
  const dispatch = useDispatch();

  const { options } = dataLayers.flowPoints;

  const toggleCheckbox = (selectedItem: ICheckboxOptions) => {
    const updatedOptionsList = options.map((option: FlowPoint) => {
      if (option.id === selectedItem.id) {
        return {
          ...option,
          checked: !option.checked,
        };
      }
      return option;
    });
    dispatch(
      updateOptions({ name: 'flowPoints', options: updatedOptionsList })
    );

    if (selectedItem.checked) {
      return removeFlowPoint(selectedItem as unknown as FlowPoint);
    }

    let poligonBounds = new google.maps.LatLngBounds();
    if (draw.type === 'polygon') {
      Map.PoligonOnMap.getPath().forEach((latlng) => {
        poligonBounds.extend(latlng);
      });
    }
    const payload = {
      ...(draw.type === 'circle' && {
        center: draw.center,
        radius: draw.radius,
      }),
      ...(draw.type === 'polygon' &&
        !poligonBounds.isEmpty() && {
          coords: draw.coords,
          bounds: poligonBounds,
        }),
      type: selectedItem.id as string,
      color: selectedItem.color as string,
    };

    dispatch(showFlowPoint(payload));
  };

  const onCheckboxClick = (selectedItem: ICheckboxOptions | boolean) => {
    if (typeof selectedItem === 'boolean') return;
    toggleCheckbox(selectedItem);
  };

  const hasDrawOnMap = draw.isActive;

  return (
    <Checkbox
      cy="AverageFamilyIncomeSwitch"
      name="averageFamilyIncome"
      type="checkbox list"
      action={onCheckboxClick}
      disabled={!hasDrawOnMap}
      disabledMessage={nls.selectRegion}
      options={options as ICheckboxOptions[]}
      optionLabel="label"
      optionValue="color"
    />
  );
}

export default FlowPointsOptions;
